// 设备图标映射 — 按 deviceType 显示对应 emoji
// 复刻 LocalSend device_type_ext.dart 的语义

import type { DeviceType } from '@kuaichuan/shared';

export function deviceIcon(deviceType?: DeviceType): string {
  switch (deviceType) {
    case 'MOBILE':
      return '📱';
    case 'DESKTOP':
      return '💻';
    case 'WEB':
      return '🌐';
    case 'HEADLESS':
      return '🖥️';
    case 'SERVER':
      return '🗄️';
    default:
      return '📶';
  }
}

export function deviceTypeLabel(deviceType?: DeviceType): string {
  switch (deviceType) {
    case 'MOBILE':
      return '手机';
    case 'DESKTOP':
      return '电脑';
    case 'WEB':
      return '浏览器';
    case 'HEADLESS':
      return '终端';
    case 'SERVER':
      return '服务器';
    default:
      return '设备';
  }
}
